import React, { memo } from "react";
import { Grid } from "@material-ui/core";
import useStyles from "./styles";
import { Images } from "config/images";

const ProgramMerchandising = memo(props => {
	const classes = useStyles();
	const { listMerchandising, handleClickProgramMerchandising } = props;

	const handleClickProgram = id => {
		handleClickProgramMerchandising(id);
	};

	return (
		<Grid classes={{ root: classes.root }}>
			<Grid classes={{ root: classes.title }}>
				<img
					src={Images.titleMerchandising}
					alt={"titleMerchandising"}
				/>
			</Grid>
			{listMerchandising.map(product => (
				<Grid
					container
					classes={{ root: classes.body }}
					key={product?.id}
					onClick={() => handleClickProgram(product.id)}
				>
					<Grid item xs={4} classes={{ root: classes.logo }}>
						<Grid classes={{ root: classes.bgLogo }} />
					</Grid>
					<Grid item xs={8} classes={{ root: classes.program }}>
						<Grid classes={{ root: classes.borderTitle }}>
							<Grid classes={{ root: classes.titleProgram }}>
								{product?.title}
							</Grid>
							<img src={Images.icInfoBlue} alt="icInfoBlue" />
						</Grid>
						<Grid classes={{ root: classes.time }}>
							TG đăng ký:{" "}
							{`${product?.startTimeRegister || "-"} - ${
								product?.endTimeRegister || "-"
							}`}
						</Grid>
						<Grid classes={{ root: classes.time }}>
							TG mua & TB:{" "}
							{`${product?.startTimeMerchandising || "-"} - ${
								product?.endTimeMerchandising || "-"
							}`}
						</Grid>
						<Grid classes={{ root: classes.time }}>
							TG trả thưởng:{" "}
							{`${product?.startTimeReward || "-"} - ${
								product?.endTimeReward || "-"
							}`}
						</Grid>
					</Grid>
				</Grid>
			))}
		</Grid>
	);
});

export default ProgramMerchandising;
